<template>
  <main class="invite-screen">
    <section class="invite-phone">
      <div class="invite-header">
        <div class="brand-row">
          <div class="brand-mark">
            <img src="/img/boarua-icon-concept-v1.png" alt="" />
          </div>
          <div>
            <h1>BOARUA</h1>
            <p>Convite de morador</p>
          </div>
        </div>

        <div class="welcome-copy">
          <span>Complete seu cadastro</span>
          <strong>Entre para sua associacao</strong>
        </div>
      </div>

      <div class="invite-panel">
        <v-alert v-if="!token" dense text type="warning" class="mb-5">
          Link de convite invalido.
        </v-alert>

          <v-form ref="form" v-model="form.valid" lazy-validation @submit.prevent="acceptInvite">
          <v-alert dense text type="info" class="billing-notice">
            Ao aceitar o convite, sua residência será vinculada à associação e poderá receber mensalidades. Seu aceite ficará registrado.
          </v-alert>

          <div class="form-section">
            <div class="field-label">
              <v-icon small color="#267062">mdi-account-outline</v-icon>
              <span>Dados pessoais</span>
            </div>

            <v-text-field
              v-model="form.name"
              :rules="[$rules.required]"
              autocomplete="name"
              outlined
              dense
              hide-details="auto"
              placeholder="Nome completo"
              class="invite-field"
            />

            <v-text-field
              v-model="form.email"
              :rules="[$rules.required, $rules.email]"
              autocomplete="email"
              outlined
              dense
              hide-details="auto"
              placeholder="E-mail"
              class="invite-field"
            />

            <div v-if="phoneLocked" class="locked-phone">
              <span>Celular do convite</span>
              <strong>{{ form.phone }}</strong>
            </div>

            <v-text-field
              v-else
              v-mask="'(##) #####-####'"
              v-model="form.phone"
              :rules="[$rules.required]"
              autocomplete="tel"
              inputmode="tel"
              maxlength="15"
              outlined
              dense
              hide-details="auto"
              placeholder="Celular"
              class="invite-field"
            />
          </div>

          <div class="form-section">
            <div class="field-label">
              <v-icon small color="#267062">mdi-map-marker-outline</v-icon>
              <span>Endereco</span>
            </div>

            <v-text-field
              v-model="form.street"
              :rules="[$rules.required]"
              autocomplete="address-line1"
              outlined
              dense
              hide-details="auto"
              placeholder="Rua"
              class="invite-field"
            />

            <div class="address-grid">
              <v-text-field
                v-model="form.number"
                :rules="[$rules.required]"
                autocomplete="address-line2"
                outlined
                dense
                hide-details="auto"
                placeholder="Numero"
                class="invite-field"
              />

              <v-text-field
                v-model="form.zip_code"
                v-mask="'#####-###'"
                inputmode="numeric"
                outlined
                dense
                hide-details="auto"
                placeholder="CEP"
                class="invite-field"
              />
            </div>

            <v-text-field
              v-model="form.complement"
              outlined
              dense
              hide-details="auto"
              placeholder="Complemento"
              class="invite-field"
            />
          </div>

          <div class="form-section">
            <div class="field-label">
              <v-icon small color="#267062">mdi-lock-outline</v-icon>
              <span>Acesso</span>
            </div>

            <v-text-field
              v-model="form.password"
              :append-icon="form.showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              :rules="[$rules.required, minPassword]"
              :type="form.showPassword ? 'text' : 'password'"
              autocomplete="new-password"
              outlined
              dense
              hide-details="auto"
              placeholder="Senha"
              class="invite-field"
              @click:append="form.showPassword = !form.showPassword"
            />

            <v-text-field
              v-model="form.passwordConfirmation"
              :append-icon="form.showConfirmPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              :rules="[$rules.required, samePassword]"
              :type="form.showConfirmPassword ? 'text' : 'password'"
              autocomplete="new-password"
              outlined
              dense
              hide-details="auto"
              placeholder="Confirmar senha"
              class="invite-field"
              @click:append="form.showConfirmPassword = !form.showConfirmPassword"
            />
          </div>

          <v-btn
            block
            depressed
            color="primary"
            class="invite-button"
            :disabled="!token || success"
            :loading="form.loading"
            type="submit"
          >
            {{ success ? "Convite aceito" : "Aceitar convite" }}
            <v-icon right small>{{ success ? "mdi-check" : "mdi-arrow-right" }}</v-icon>
          </v-btn>

          <button class="text-action" type="button" @click="goToLogin">
            Ja tenho acesso
          </button>
        </v-form>
      </div>
    </section>
  </main>
</template>

<script>
import axios from "axios";

export default {
  name: "AcceptInvite",

  data: () => ({
    token: "",
    phoneLocked: false,
    success: false,
    form: {
      valid: true,
      loading: false,
      showPassword: false,
      showConfirmPassword: false,
      name: "",
      phone: "",
      email: "",
      street: "",
      number: "",
      complement: "",
      zip_code: "",
      password: "",
      passwordConfirmation: "",
    },
  }),

  mounted() {
    this.token = String(this.$route.query.token || "");

    if (this.$route.query.phone) {
      this.form.phone = this.formatPhone(this.$route.query.phone);
      this.phoneLocked = true;
    }

    if (this.$route.query.email) {
      this.form.email = String(this.$route.query.email);
    }
  },

  methods: {
    normalizePhone(value) {
      return String(value || "").replace(/\D/g, "");
    },

    formatPhone(value) {
      const digits = this.normalizePhone(value).slice(0, 11);

      if (digits.length <= 2) return digits;
      if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;

      return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    },

    minPassword(value) {
      return String(value || "").length >= 6 || "Senha deve possuir pelo menos 6 caracteres";
    },

    samePassword(value) {
      return value === this.form.password || "As senhas nao conferem";
    },

    extractError(error) {
      if (error && error.content && error.content.error && error.content.error.message) {
        return error.content.error.message;
      }

      if (error && error.response && error.response.data && error.response.data.content && error.response.data.content.error) {
        return error.response.data.content.error.message;
      }

      return "Nao foi possivel aceitar o convite.";
    },

    async acceptInvite() {
      if (!this.$refs.form.validate() || !this.token) return;

      this.form.loading = true;

      try {
        await axios.post("/association-invites/accept", {
          token: this.token,
          name: this.form.name,
          phone: this.normalizePhone(this.form.phone),
          email: this.form.email,
          street: this.form.street,
          number: this.form.number,
          complement: this.form.complement || null,
          zip_code: String(this.form.zip_code || "").replace(/\D/g, "") || null,
          password: this.form.password,
        });

        this.success = true;
        this.$dialog.notify.success("Convite aceito com sucesso", {
          position: "top-right",
          timeout: 4000,
        });

        this.$router.push({ path: "/login", query: { phone: this.normalizePhone(this.form.phone) } });
      } catch (error) {
        this.$dialog.notify.error(this.extractError(error), {
          position: "top-right",
          timeout: 5000,
        });
      } finally {
        this.form.loading = false;
      }
    },

    goToLogin() {
      this.$router.push({ path: "/login", query: { phone: this.normalizePhone(this.form.phone) } });
    },
  },
};
</script>

<style scoped lang="scss">
.invite-screen {
  align-items: center;
  background:
    radial-gradient(circle at 18% 12%, rgba(255, 255, 255, 0.74) 0, rgba(255, 255, 255, 0) 30%),
    linear-gradient(180deg, #d9e9e3 0%, #c8ddd5 100%);
  color: #111827;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  overflow-x: hidden;
  padding: 20px;
}

.invite-phone {
  background: #fdfefe;
  border: 1px solid rgba(5, 122, 61, 0.1);
  border-radius: 24px;
  box-shadow: 0 26px 70px rgba(6, 52, 32, 0.16);
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: 410px;
  overflow: hidden;
  position: relative;
  width: min(100%, 410px);
}

.invite-header {
  background: #267062;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 190px;
  overflow: hidden;
  padding: 24px 26px 26px;
  position: relative;

  &::before,
  &::after {
    background: rgba(255, 255, 255, 0.06);
    border-radius: 999px;
    content: "";
    position: absolute;
  }

  &::before {
    height: 162px;
    left: -62px;
    top: 76px;
    width: 214px;
  }

  &::after {
    height: 118px;
    right: -22px;
    top: 32px;
    width: 130px;
  }
}

.brand-row {
  align-items: center;
  display: flex;
  gap: 12px;
  position: relative;
  z-index: 1;

  h1 {
    font-size: 22px;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 1.1;
    margin: 0;
  }

  p {
    color: rgba(255, 255, 255, 0.76);
    font-size: 13px;
    margin: 3px 0 0;
  }
}

.brand-mark {
  align-items: center;
  background: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 13px;
  display: flex;
  height: 48px;
  justify-content: center;
  overflow: hidden;
  width: 48px;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
}

.welcome-copy {
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
  z-index: 1;

  span {
    color: rgba(255, 255, 255, 0.72);
    font-size: 13px;
    font-weight: 700;
  }

  strong {
    color: #ffffff;
    font-size: 23px;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 1.12;
  }
}

.invite-panel {
  padding: 24px 24px 26px;
}

.billing-notice {
  margin-bottom: 18px;
}

.form-section {
  margin-bottom: 20px;

  &:last-of-type {
    margin-bottom: 14px;
  }
}

.field-label {
  align-items: center;
  color: #267062;
  display: flex;
  font-size: 14px;
  font-weight: 900;
  gap: 7px;
  margin-bottom: 12px;
}

.invite-field {
  margin-bottom: 0;

  ::v-deep .v-input__slot {
    border-radius: 10px;
    min-height: 44px !important;
  }

  ::v-deep input {
    font-size: 15px;
  }
}

.form-section > .invite-field,
.form-section > .locked-phone,
.form-section > .address-grid {
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.locked-phone {
  background: #f6faf8;
  border: 1px solid rgba(38, 112, 98, 0.22);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 12px;
  padding: 10px 12px;

  span {
    color: #66756f;
    font-size: 12px;
    font-weight: 700;
  }

  strong {
    color: #12221c;
    font-size: 16px;
    font-weight: 800;
  }
}

.address-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(0, 1fr) 138px;

  .invite-field {
    margin-bottom: 0;
  }
}

.invite-button {
  border-radius: 12px;
  font-size: 15px;
  font-weight: 900;
  height: 48px;
  letter-spacing: 0;
  margin-top: 2px;
  text-transform: none;
}

.text-action {
  background: transparent;
  border: 0;
  color: #267062;
  cursor: pointer;
  display: block;
  font-size: 14px;
  font-weight: 900;
  margin: 17px auto 0;
  padding: 0;
}

@media (max-width: 420px) {
  .invite-screen {
    align-items: stretch;
    padding: 0;
  }

  .invite-phone {
    border: 0;
    border-radius: 0;
    max-width: none;
    min-height: 100vh;
    width: 100%;
  }

  .invite-header {
    min-height: 184px;
    padding: 22px 22px 24px;
  }

  .invite-panel {
    padding: 24px 20px 28px;
  }

  .address-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 0;
  }
}
</style>
